export const skillCategoriesData = [
  {
    title: "Frontend Development",
    skills: ["React", "Next.js", "JavaScript", "TypeScript", "HTML5/CSS3", "Tailwind CSS", "Bootstrap", "SASS", "Responsive Design"]
  },
  {
    title: "Backend & Database",
    skills: ["PHP", "ASP.NET", "C#", "MySQL"]
  },
  {
    title: "WordPress Development",
    skills: ["Custom Themes", "Custom Post Types", "Custom Plugins", "Advanced Custom Fields"]
  },
  {
    title: "AI & Automation",
    skills: ["Custom GPT Creation", "Prompt Engineering", "AI Tool Development", "GPT Testing"]
  },
  {
    title: "Tools & Workflow",
    skills: ["Git & GitHub", "VS Code", "Research & Documentation"]
  },
  {
    title: "Professional Skills",
    skills: ["Time Management", "Leadership Skills", "Cross-functional Collaboration", "Problem Solving", "Mentoring & Training"]
  }
];